export const stakeholderRoleToType = (role?: string) => {
  switch (role) {
    case 'Farmer Group Leader':
      return 'FARMER_GROUP_LEADER';
    case 'Paddy Buyer':
      return 'PADDY_BUYER';
    case 'Machine Owner':
      return 'MACHINE_OWNER';
    default:
      return undefined;
  }
};
